import { render } from "./bouns.vue?vue&type=template&id=fe91c84c&scoped=true"
import script from "./bouns.vue?vue&type=script&lang=js"
export * from "./bouns.vue?vue&type=script&lang=js"

import "./bouns.vue?vue&type=style&index=0&id=fe91c84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe91c84c"]])

export default __exports__